import React, { useEffect, useState } from 'react'
import TableSkeleton from '../../hoc/TableSkeleton';
import FormInputs from '../../components/UI/FormInputs';
import Buttons from '../../components/UI/Buttons';
import TableGrid from '../../components/UI/TableGrid';
import AddRandomVisitScheduler from './AddRandomVisitScheduler';
import CompanyService from '../../services/CompanyService';
import LookupService from '../../services/LookupService';
import DropDownService from '../../services/DropDownService';
import RandomGeneratorConfigService from '../../services/RandomGeneratorConfigService';
import { toQueryString } from '../../utils/commonUtils';
import Icons from '../../components/UI/Icons';
import WithRoutify from '../../hoc/WithRoutify';
import { OK } from '../../utils/constant';
import PERMISSIONS from '../../utils/AclPermissions';

const RandomGeneratorConfig = (props) => {
       const tableHeaders = [
         {
           label: "Status",
           name: "status",
           key: "status",
         },
      {
        label: "Company Name",
        key: "company_name",
        type: "",
        inputType: "TextInput",
        sortName: "company_id",
      },
      {
        label: "Visit Category",
        key: "visit_category",
        type: "",
        inputType: "TextInput",
        sortName: "visit_category",
      },
        {
        label: "No Of Appoinments",
        key: "selection_number",
        type: "",
        inputType: "TextInput",
        sortName: "selection_number",
      },
      {
        label: "Active/Inactive",
        // name: "status",
        key: "active",
      },
      
      { label: "Action", key: "action", type: "Actions" },
      //  more columns as needed
    ];
     
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [payload, setPayload] = useState()
    const [filters, setFilters] = useState({
        search_query: "",
      })
    const [tableRecords, setTableRecords] = useState({
        tableHeaders: tableHeaders,
        tableRows: {
           type: "default",
            status: 1000,
            data: [],
        },
        pagination: {
          page: 1,
          perPage: 25,
          totalRecords: 0,
          sort_by: "",
          sort_order: "asc",
          search: {},
        },
    })
    const [companyList, setCompanyList] = useState([]);
    const [visitCategory, setVisitCategory] = useState([]);
    const [activityList, setActivityList] = useState([]);
    useEffect(() => {
        getCompanyList();
        fetchVisitCategory()
        // fetchActivities()
        fetchrandomVisitSchedulerList(tableRecords.pagination);
    }, []);
  const fetchrandomVisitSchedulerList = async (filters = tableRecords.pagination) => {
    console.log("Fetching random visit scheduler list with filters: ", filters);
    props.Loader(true);
    try {
      const queryString = toQueryString({
        ...tableRecords.pagination,
        ...filters,
      });
      const response = await RandomGeneratorConfigService.getRandomVisitSchedulerList(queryString);
      console.log("Random Visit Scheduler List Response: ", response);
      let data = [];
      let totalRecords = 0;
      if (response && response?.data) {
        response.data.data.forEach((item, index) => {
          let statusIcon="blue";
          if (Boolean(Number(item.is_completed))) {
            statusIcon = "green";
          }
          if(!Boolean(Number(item.is_active))){
            statusIcon = "red";
          }
          data.push({
            Index: index,
            isHeading: false,
            rowId: item.id,
            data: {
              // isActive: item.is_active,
              status: {
                value:
                  <a className="px-1" title={"Status"} >
                    <Icons
                      fontSize={'15px'}
                      type={statusIcon} />
                  </a>
              },
              company_name: item.company ? item.company.name : "",
              visit_category: item.visit_category,
              selection_number: item.selection_number,
              // active: item.active ? "Yes" : "No",
              active: {
                value:
                  <a className="" title={item.is_active ? "Active" : "Inactive"}>
                    <span className="">
                      <label className="switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="activationstatus"
                          id="activationstatus"
                          checked={item.is_active}
                          // onChange={(e) => this.updateFormData(list.emr_form_id,{ is_active: !list.is_active})}
                          onChange={() => updateFormData(item.id, { is_active: !item.is_active })}
                        />
                        <span className="slider sh_emrststus"></span>
                      </label>
                    </span>
                  </a>
              },
              action: [
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "Search",
                  title: "View",
                  type: "GridEdit",
                  acl:PERMISSIONS.RANDOM_GENERATOR.EDIT,
                  clickHandler: (rowId, data) => editHandler(rowId, item),
                },
                {
                  className: "btn btn-icon btn-transparent-dark",
                  iconType: "Remove",
                  title: "Delete",
                  isDelete: true,
                  acl:PERMISSIONS.RANDOM_GENERATOR.DELETE,
                  clickHandler: () => deleteHandler(item.id),
                },
              ],
            },
          });
        });
        totalRecords = response.pagination.totalCount || data.length
      }
      setTableRecords((prevState) => ({
        ...prevState,
        tableRows: {
          type: "default",
          status: 200,
          data: data,
        },
        pagination: {
          ...prevState.pagination,
          ...filters,
          totalRecords: totalRecords,
        },
      }));
    } catch (error) {
      setTableRecords((prev) => ({
        ...prev,
        tableRows: {
          ...tableRecords.tableRows,
          status: 500,
        },
      }))

      console.error("Error fetching random visit scheduler list:", error);
    }
    finally {
      props.Loader(false);
    }
  };
    const editHandler = (rowId, data) => {
        console.log("Edit Handler - Row ID: ", rowId, "Data: ", data);
        const editData={
            ...data,
            "optional_services": data.optional_services? data.optional_services.split(',').map(s => s.replace(/"/g, "")):[]
        }
        setPayload(editData);
        setIsModelOpen(true);
    }
    const deleteHandler = async (id) => {
    console.log("Delete Handler - ID: ", id);
        props.Loader(true);
        try {
            const response = await RandomGeneratorConfigService.deleteRandomVisitScheduler(id);
                // Optionally, you can refetch the list after deletion
                fetchrandomVisitSchedulerList(tableRecords.pagination);
                props.Toast.success("Appoinment deleted successfully");
        } catch (error) {
            props.Toast.error("Error deleting random visit scheduler, please try again later");
            console.error("Error deleting random visit scheduler:", error); 
        }
        finally{
           props.Loader(false);
        }

    }
    const getCompanyList = async () => {
        try {
            const response = await CompanyService.getCompanies();
            console.log("Company List Response: ", response);
            if (response.data && response.data.data) {
                  let data = [];  
      response.data.data.forEach((item) => {
            data.push({
                        label: item.name,
                        value: item.company_uuid
                    });
            });
       setCompanyList(data);
            }
        } catch (error) {
            console.error("Error fetching company list:", error);
        }

    }
      const fetchVisitCategory = async ()=>{
    try{
      const data = await LookupService.getLookupByKey("VisitCategory");
      let visitStatusArr = [{ label: '-Select Category-', value: '' }];  
      if(data && data.length > 0)
      data.forEach((item) => {
            visitStatusArr.push({
                        label: item.value,
                        value: item.value
                    });
            });
        setVisitCategory(visitStatusArr);
    }catch(e){
    }
  };
    const fetchActivities = async () => {
  
      const response = await DropDownService.getActivityDropdownList(null);
      console.log("res11", response);
      
      let opt = [{ "label": 'ALL', value: 'ALL' }];
          response.forEach((itm, ind) => {
            opt.push({ label: itm.activity_name, value: itm.actitivity_id,activity_type: itm.activity_type})
          });
      setActivityList(opt);
    }
  const addFormHandler = (isClose = false) => {
    if(isClose){
      //payload set remove
      setPayload(null);
    }
    setIsModelOpen(!isModelOpen);
  };
  const onChangeFiltersHandler = (key,val) => {
    setFilters((prevFilters) => ({
        ...prevFilters,
        [key]: val,
    }));
  };
  const updateFormData = async (id, data) => {
    const {Toast} =props;
    try {
      const payload = {
        field_update: 1,
        ...data,
      };
      const response = await RandomGeneratorConfigService.updateActiveStatus(null, id, payload);
      if (response?.code == OK ) {
        Toast.success("Appointment Update successfully.")
        fetchrandomVisitSchedulerList(tableRecords.pagination);
      } else {
        Toast.error("Failed to update.");
      }
      
    } catch (error) {
      console.error("Error updating form data:", error);
    }
  };
  const submitFiltersHandler = () => {
    // Logic to submit filters
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      search: filters,
    };
      setTableRecords((prevState) => ({
        ...prevState,
        pagination: queryfilters
      }));
    console.log("Filters submitted: ", queryfilters);
    
    fetchrandomVisitSchedulerList(queryfilters);
  };
    const clearFiltersHandler = () => {
        // Logic to clear filters
     setFilters({
      search_query: "",})
    const queryfilters = {
      ...tableRecords.pagination,
      page: 1,
      search: {},
    }
    fetchrandomVisitSchedulerList(queryfilters);
    };  

  return (
   <>
          {isModelOpen ? ( 
            <AddRandomVisitScheduler
              // modelTitle={`ICD-10`}
              isOpen={isModelOpen}
            //   fetchIcdList={fetchIcdList}
              addFormHandler={addFormHandler}
            //   activeEditId={activeEditId}
            companyList={companyList}
            visitCategory={visitCategory}
            activityList={activityList}
            payload={payload}
            fetchrandomVisitSchedulerList={fetchrandomVisitSchedulerList}
            />
          ) : (
            <></>
          )}
          <TableSkeleton
            tableRecords={tableRecords}
            addFormHandler={addFormHandler}
            acl={PERMISSIONS.RANDOM_GENERATOR.CREATE}
            content={"Schedule Appoinment List"}
          >
            <div className="sh_cardBox sh_cardbglight">
              <div className="sh_cardHeader">
                <div className="form-group d-flex mb-0 justify-content-between align-items-center formheader">
                  <h6 class="text-lg f-500 mb-0">Schedule Appoinment List</h6>
                  <div className="d-flex">
                    <div className="form-group-fields row mr-2">
                      <div className="col-12 px-1 d-flex">
                        <div className="input-group input-group-joined input-group-solid">
                          <FormInputs
                            placeholder="Search "
                            value={filters["search_query"]}
                            changeHandler={(val) =>
                              onChangeFiltersHandler("search_query", val)
                            }
                            className="form-control"
                          />
                        </div>
                        <div className="btn-group pl-2">
                          <button
                            className="btn btn-primary"
                            onClick={() => submitFiltersHandler()}
                          >
                            Search
                          </button>
                          <button
                            className="btn btn-outline-secondary"
                            onClick={() => clearFiltersHandler()}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="addAction">
                      <div className="btn-group">
                        <Buttons
                          clickHandler={() => {
                            addFormHandler();
                            //  setState({ activeEditId: "" });
                          }}
                          className="btn btn-primary"
                          acl={PERMISSIONS.RANDOM_GENERATOR.CREATE}
                          label={"Add"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div className="sh_cardBody p-0">
                <TableGrid
                  addFormHandler={() => addFormHandler()}
                  hasPagination={true}
                  fetchTableRecords={(filters) => fetchrandomVisitSchedulerList(filters)}
                  {...tableRecords}
                />
              </div>
            </div>
          </TableSkeleton>
        </>
  )
}

export default WithRoutify(RandomGeneratorConfig)